var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
        fullscreen: true,
        "ok-disabled": _vm.disableSubmit,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _vm.colTemplateType == "1" ||
      _vm.colTemplateType == "2" ||
      _vm.colTemplateType == "4" ||
      _vm.colTemplateType == "8"
        ? _c("cms-content-tbl-form", {
            ref: "realForm",
            attrs: {
              disabled: _vm.disableSubmit,
              colidProps: this.colid,
              pageLangCode: _vm.pageLangCode,
              contentPath: this.contentPath
            },
            on: { ok: _vm.submitCallback }
          })
        : _vm._e(),
      _vm.colTemplateType == "3"
        ? _c("cms-content-tbl-form3", {
            ref: "realForm",
            attrs: {
              disabled: _vm.disableSubmit,
              colidProps: this.colid,
              pageLangCode: _vm.pageLangCode,
              contentPath: this.contentPath
            },
            on: { ok: _vm.submitCallback }
          })
        : _vm._e(),
      _vm.colTemplateType == "5"
        ? _c("cms-content-tbl-form5", {
            ref: "realForm",
            attrs: {
              disabled: _vm.disableSubmit,
              colidProps: this.colid,
              pageLangCode: _vm.pageLangCode,
              contentPath: this.contentPath
            },
            on: { ok: _vm.submitCallback }
          })
        : _vm._e(),
      _vm.colTemplateType == "6"
        ? _c("cms-content-tbl-form6", {
            ref: "realForm",
            attrs: {
              disabled: _vm.disableSubmit,
              colidProps: this.colid,
              pageLangCode: _vm.pageLangCode,
              contentPath: this.contentPath
            },
            on: { ok: _vm.submitCallback }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }